import { render } from "./TargetSelection.vue?vue&type=template&id=685dbb34&scoped=true"
import script from "./TargetSelection.vue?vue&type=script&lang=js"
export * from "./TargetSelection.vue?vue&type=script&lang=js"

import "./TargetSelection.vue?vue&type=style&index=0&id=685dbb34&scoped=true&lang=css"

import exportComponent from "/Users/avinduhewa/Documents/Projects/bokaklip/payl-firebase/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685dbb34"]])

export default __exports__